import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from '@mui/material';
import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';

import ModalNotification from '@/shared/components/dialogs/ModalNotification';
import { AppPath } from '@/shared/constants/path';

type SearchProductNotFoundProps = {
  onClose: () => void;
};

const SearchProductNotFound: FC<SearchProductNotFoundProps> = ({ onClose }) => {
  const { t } = useTranslation(['checkout', 'common']);

  return (
    <ModalNotification
      size='sm'
      fullWidth
      open
      onClose={onClose}
      dialogProps={{
        title: t('checkout:productNotFound'),
        content: (
          <Stack sx={{ py: 1 }}>
            <Typography variant='body1' sx={{ mb: 2 }}>
              {t('checkout:productNotFoundMessage')}
            </Typography>
            <Typography variant='body1' sx={{ mb: 2 }}>
              {t('checkout:productNotFoundInstructions')}
            </Typography>

            <Link href={`${AppPath.Products}/add`} target='_blank'>
              Create a product
            </Link>
          </Stack>
        ),
        actions: [
          {
            label: t('common:close'),
            onClick: onClose,
          },
        ],
      }}
    />
  );
};

export default SearchProductNotFound;
